import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import ButtonCta from '@components/atoms/button-cta'
import TabPanel from '@components/tab-panel/index'
import TabPanelVariant from '@components/tab-panel-variant/index'
import { BlueLongRightArrow } from '@components/atoms/icons'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { gsap } from 'gsap'
import useStyles from './fullheight-tablist.styles'

const FullHeightTablist = (props) => {
  const {
    heading,
    supportiveCopy,
    ctaLabel,
    ctaLink,
    desktopBackgroundImage,
    accordionCollection,
    variant,
  } = props

  const styles = useStyles()
  const isMobile = useMediaQuery('(max-width:1200px)')
  const [tabValue, setTabValue] = React.useState(0)

  const handleChange = (event, newTabValue) => {
    setTabValue(newTabValue)
    if (newTabValue !== tabValue) {
      gsap.to(`.transitional-img${newTabValue}`, { zIndex: 2 })
      gsap.to(`.transitional-img${newTabValue}`, {
        duration: 0.25,
        autoAlpha: 1,
      })
      gsap.fromTo(`.transitional-img${tabValue}`, { autoAlpha: 1 }, { duration: 0.75, zIndex: 0, autoAlpha: 0 })
    }
  }

  useEffect(() => {
    // show first img immediately
    gsap.set('.transitional-img', {
      autoAlpha: 0,
      zIndex: 0,
      onComplete: () => {
        gsap.to(`.transitional-img${tabValue}`, { autoAlpha: 1, zIndex: 2 })
      },
    })
  })

  const TabPanelComponent = variant ? TabPanelVariant : TabPanel

  return (
    <div className={styles.fullheightTablist}>
      <div className={styles.splitContainer}>
        <div className={styles.imagerySection}>
          {accordionCollection?.items.length > 0 && accordionCollection.items.map((data, i) => (
            <img
              className={`${styles.imagerySectionImg} transitional-img transitional-img${i}`}
              key={`full-height-bg-image${i + 1}`}
              alt=""
              src={data.backgroundImage?.url || desktopBackgroundImage?.url || '/images/coach-testimonial-bg.png'}
            />
          ))}
        </div>
      </div>

      <div className={styles.maxWidthContainer}>
        <div className={styles.introContainer}>
          <div>
            <h2 className={styles.heading}>{heading}</h2>
            <p className={styles.supportiveCopy}>{supportiveCopy}</p>
          </div>
          <div className={styles.ctaContainer}>
            <ButtonCta href={ctaLink} variant="contained" color="primary">{ctaLabel}</ButtonCta>
          </div>
          <div className={styles.tabContainer}>
            <Box>
              <Tabs value={tabValue} onChange={handleChange} aria-label="Explore the following four categories">
                {accordionCollection?.items?.length > 0
                && accordionCollection.items.map((accordion, i) => (
                  <Tab
                    className={styles.accordionTitle}
                    key={`workingolf-tab-${i + 1}`}
                    label={(
                      <>
                        <div className={`${styles.titleIcon} fullheight-tablist-list-icon`}>
                          <object
                            role="presentation"
                            id={`scenic-accordion-object-${i}`}
                            width="16"
                            height="16"
                            className=""
                            aria-label="tablist item icon"
                            type="image/svg+xml"
                            data={accordion?.accordionTitleIcon?.url}
                          />
                        </div>
                        {accordion?.accordionTitle}
                        <div className={`${styles.isSelectedArrowContainer} is-selected-arrow-container`}>
                          <div className={`${styles.isSelectedArrow} is-selected-arrow`}>
                            <BlueLongRightArrow width={isMobile ? '460' : '560'} />
                          </div>
                        </div>
                      </>
                    )}
                  />
                ))}
              </Tabs>
            </Box>
            {accordionCollection?.items?.length > 0
            && accordionCollection.items.map((accordion, i) => (
              <TabPanelComponent
                tabValue={tabValue}
                tabIndex={i}
                key={`workingolf-tabpanel-${i + 1}`}
                {...accordion}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

FullHeightTablist.propTypes = {
  heading: PropTypes.string,
  supportiveCopy: PropTypes.string,
  ctaLabel: PropTypes.string,
  ctaLink: PropTypes.string,
  desktopBackgroundImage: PropTypes.object,
  accordionCollection: PropTypes.object,
  variant: PropTypes.bool,
}

FullHeightTablist.defaultProps = {}

export default FullHeightTablist
